<template>
  <div class="pa16  b-fff minh100p">
    <router-view />
  </div>
</template>
